import styled from 'styled-components';

import {Label} from 'components/pages/DocumentsCreate/InvoiceNew/styled';
import {colors, font} from 'theme';

export const HeaderLabel = styled(Label)`
    white-space: nowrap;
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    margin-left: auto;

    > button {
        width: auto;
        white-space: nowrap;
    }
`;

export const Section = styled.section`
    margin: 0;
`;

export const SectionTitle = styled.h2`
    margin: 0 0 10px;
    padding-left: 2px;
    color: ${colors.black};
    font-family: ${font.family.primary};
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
`;

export const StepContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const Grid = styled.div<{columns?: number}>`
    display: grid;
    grid-template-columns: repeat(${({columns = 2}) => columns}, minmax(0, 1fr));
    gap: 10px;

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const FieldError = styled.div`
    min-height: 18px;
    margin-top: 4px;
    color: ${colors.danger};
    font-size: 12px;
`;

export const CodeControls = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 150px 130px auto;
    align-items: end;
    gap: 12px;

    @media (max-width: 900px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const Lines = styled.div`
    display: grid;
    gap: 12px;
    margin-top: 20px;
`;

export const LineCard = styled.div`
    padding: 16px 18px;
    border: 1px solid ${colors.border};
    border-radius: 6px;
`;

export const LineHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid ${colors.border};
`;

export const Code = styled.div`
    overflow-wrap: anywhere;
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    font-weight: 600;
`;

export const LineDetails = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;
    padding-top: 14px;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 575px) {
        grid-template-columns: 1fr;
    }
`;

export const DetailLabel = styled.div`
    margin-bottom: 5px;
    color: ${colors.textMuted};
    font-size: 12px;
`;

export const DetailValue = styled.div`
    overflow-wrap: anywhere;
    font-size: 14px;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 28px;

    > button {
        width: auto;
    }
`;

export const LinesTable = styled.div`
    overflow-x: auto;

    > div {
        min-width: 1100px;
    }
`;

export const ExistingLinesTable = styled(LinesTable)<{hideHeader: boolean}>`
    .thead {
        display: ${({hideHeader}) => (hideHeader ? 'none' : 'block')};
    }

    .tbody .tr.transport-incomplete {
        background-color: ${colors.dangerSecondary};
    }

    .tbody .tr.transport-modal {
        cursor: pointer;
    }
`;

export const TableHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;

    > div {
        display: flex;
        align-items: center;
    }

    small {
        color: ${colors.textMuted};
        font-size: 12px;
        font-weight: 400;
    }
`;

export const CodeValue = styled.div<{depth?: number}>`
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 4px;
    padding-left: ${({depth = 0}) => depth * 16}px;
    overflow-wrap: anywhere;
    font-size: 13px;
`;

export const ProductCode = styled.span`
    color: ${colors.textMuted};
    font-size: 12px;
`;

export const LineActions = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const TransportCodesModalContent = styled.div`
    max-height: 675px;
    overflow: auto;

    > div {
        min-width: 960px;
    }

    .tbody .tr.transport-incomplete {
        background-color: ${colors.dangerSecondary};
    }
`;
